export default Object.freeze({
  DEVELOP: 'dev',
  TEST: 'qa',
  PRODUCTION: 'prod',
});
